import { Navigate, useLocation } from "react-router-dom";
import { DASHBOARD, LOGIN } from "../constants/paths";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";

export interface JWTToken {
  email: string;
  exp: number;
  iat: number;
  idCliente: string;
  idEmpresa: string;
  name: string;
  nbf: number;
  primarysid: string;
  role: string;
  expiracao?: string;
  primeiro?: string;
}

export const PrivateRoute = ({ children, id, permsList }: any) => {
  const [cookies] = useCookies();
  const token = cookies.token
    ? cookies.token
    : window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");

  let isPermited = 0;

  if (id !== 24 && Number(jwtToken.role) !== 3) {
    isPermited =
      permsList && id !== -2
        ? permsList.findIndex(
            (perm: any) => perm.idPermissoes == id || perm.idPermissoes == 1
          )
        : 0;
  } else if (id === 24 && Number(jwtToken.role) !== 3) {
    isPermited =
      permsList && id !== -2
        ? permsList.findIndex((perm: any) => perm.idPermissoes == id)
        : 0;
  }

  const isAuthenticated = cookies.auth ? cookies.auth : false;

  if (isPermited === -1 && isAuthenticated) {
    return <Navigate to={DASHBOARD} />;
  }

  return isAuthenticated ? children : <Navigate to={LOGIN} />;
};
